import academicUtilsService from './academicUtils.api';
import parentInventoryService from './parentInventory.api';
import appointmentServices from './appointment.api';
import childCountServices from './childCount.api';

export {
  academicUtilsService,
  parentInventoryService,
  appointmentServices,
  childCountServices,
};

export default {
  ...parentInventoryService,
  ...academicUtilsService,
  ...appointmentServices,
  ...childCountServices,
};
